import { MetaradarStateSnapshot } from '@app/model/metaradar/MetaradarStateSnapshot';
import React from 'react';
import { useSelectedCompanyHotel } from '@app/site/secured/rateshopper/rates/provider/useSelectedCompanyHotel';
import Utilities from '@util/Utilities';

const MetaradarSummaryFragment: React.FunctionComponent<{
	metaradarStateSnapshot: MetaradarStateSnapshot
}> = ({ metaradarStateSnapshot }) => {

	const { companyHotel } = useSelectedCompanyHotel();

	const daysCount = metaradarStateSnapshot.dailyItems.length;
	const calculation = metaradarStateSnapshot.calculateUndercutRegionsDaysPercentage(companyHotel.metaradarSettings!.providers, companyHotel.metaradarSettings!.threshold || 0)

	return <div className="p-6 text-sm text-gray-700">
		<p>
			{`In the next ${daysCount} days, at least one provider undercuts your direct rate on ${Utilities.formatDouble(calculation, 0)}% of dates on all locations.`}
		</p>

	</div>;

};

export default MetaradarSummaryFragment;